<template>
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 184.64 151.22"
  >
    <path
      fill="#c6c5c5"
      d="m92,46.69s-42-7-42,25,25,34,25,34c0,0-5,42,1,43s9-6,9-6c0,0,2,8,6,8s7-7,7-7c0,0,3,6,9,7s30,0,41-5,12-17,12-17c0,0,5,3,11,3s11-5,13-14-1-12-5-14-17,8-17,8c0,0-6-14-13-21s-30-14-34-14-2-10-2-10c0,0,69-3,63-24s-70,12-70,12c0,0,52-42,46-51s-29-4-60,43Z"
    />
    <ellipse
      fill="#f69a9f"
      cx="73.32"
      cy="71.87"
      rx="5.69"
      ry="6.73"
      transform="translate(-25.58 99.43) rotate(-60)"
    />
    <path
      fill="#f69a9f"
      d="m115,58.69s8-11,25-16,26-6,28,0-17,12-23,14-19,7-30,2Z"
    />
    <path
      fill="#f69a9f"
      d="m64,52.69s1.15-1.38-.43-2.69-2.82-.38-4.2,1.65-.38,4.04-.38,4.04c0,0,5,3,8,1s-1-5-3-4Z"
    />
    <g>
      <circle
        cx="79.2"
        cy="63.3"
        r="4.5"
      />
      <circle
        fill="#fff"
        cx="80.25"
        cy="63.42"
        r="1.73"
      />
    </g>
    <path
      fill="#020202"
      stroke-width="2px"
      stroke-miterlimit="10"
      d="m65,62.69s-3,1-6-1,0-6,0-6c0,0-2,2-5,1"
    />
    <g>
      <path
        fill="#66260f"
        d="m0,71.69v70s3,8,17,8,16-6,16-6l2-71s-3-8-17-8S0,71.69,0,71.69Z"
      />
      <ellipse
        fill="#c75b28"
        cx="17.5"
        cy="71.69"
        rx="17.5"
        ry="8"
      />
      <circle
        fill="#faa723"
        cx="9.5"
        cy="72.19"
        r="4.5"
      />
      <ellipse
        fill="#fbbd21"
        cx="18.5"
        cy="74.19"
        rx="4.5"
        ry="3.5"
      />
      <ellipse
        fill="#faa723"
        cx="26.5"
        cy="71.19"
        rx="5.5"
        ry="4.5"
      />
      <ellipse
        fill="#fbbd21"
        cx="24.5"
        cy="65.19"
        rx="4.5"
        ry="3.5"
      />
      <ellipse
        fill="#fbbd21"
        cx="15.27"
        cy="67.84"
        rx="3.5"
        ry="4.5"
        transform="translate(-46.15 35.25) rotate(-49.36)"
      />
      <ellipse
        fill="#cb3727"
        cx="19.5"
        cy="64.15"
        rx="4.5"
        ry="4.54"
      />
    </g>
    <path
      fill="none"
      stroke-miterlimit="10"
      d="m139,101.69s-14.7,0-21,13-1.05,26-1.05,26c0,0-17.85-8-18.9,1s15.77,8.85,15.77,8.85"
    />
    <path
      fill="none"
      stroke-miterlimit="10"
      d="m98,141.69s-.86,9.62-8.35,9c-7.39-.61-6.49-43-6.49-43l1.48,34.26s-3.34,7.74-8.9,6.74-.93-43-.93-43"
    />
  </svg>
</template>
